import { render, staticRenderFns } from "./FreeModeEnd.vue?vue&type=template&id=6f89511c"
import script from "./FreeModeEnd.vue?vue&type=script&lang=js"
export * from "./FreeModeEnd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports